import {
  AfterContentInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { BootstrapSemanticVariation } from '@app/utils/bootstrap';
import { isNotBlank } from '@app/utils/string';

type CardType = 'accent' | 'border' | 'bg';

@Component({
  selector: 'portal-card',
  templateUrl: './portal-card.component.html',
  host: {
    class: 'portal-card',
  },
  standalone: false,
})
export class PortalCardComponent implements AfterContentInit, OnChanges {
  @ViewChild('footer', { static: true })
  footer: ElementRef<Element>;

  @ViewChild('header', { static: true })
  header: ElementRef<Element>;

  @Input()
  classes: string = '';

  @Input()
  bodyClasses: string = '';

  @Input()
  collapsed: boolean = false;

  @Input()
  state?: BootstrapSemanticVariation | Partial<Record<BootstrapSemanticVariation, boolean>>;

  /**
   * @deprecated TODO remove the type
   */
  @Input()
  type?: CardType = 'border';

  cardClass: string;

  // In order to explicitly hide footer from outside
  @Input()
  hideFooter: boolean = false;

  @Input()
  hideHeader: boolean = false;

  showFooter: boolean = false;
  showHeader: boolean = false;

  ngAfterContentInit() {
    this.footerChanged();
    this.headerChanged();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('classes' in changes || 'state' in changes || 'type' in changes) {
      this.calcState(
        changes.classes?.currentValue ?? this.classes,
        changes.state?.currentValue ?? this.state,
        changes.type?.currentValue ?? this.type
      );
    }
  }

  private calcState(
    classes: string,
    state: BootstrapSemanticVariation | Partial<Record<BootstrapSemanticVariation, boolean>>,
    type: CardType
  ) {
    let cardClass: string;

    if (state != null && type != null) {
      if (typeof state === 'string') {
        cardClass = `card--${state}`;
      } else {
        cardClass = Object.entries(state)
          .filter(([, value]) => value === true)
          .map(([key]) => `card--${key}`)
          .join(' ');
      }
    } else {
      cardClass = '';
    }

    if (isNotBlank(classes)) {
      this.cardClass = `${cardClass} ${classes}`;
    } else {
      this.cardClass = cardClass;
    }
  }

  public footerChanged() {
    this.showFooter = this.footer.nativeElement.children.length > 0 && this.hideFooter !== true;
  }

  public headerChanged() {
    this.showHeader = this.header.nativeElement.children.length > 0 && this.hideHeader !== true;
  }
}
